module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_external_link_gold_small-2c44aa917ba9b797f364100f550937b6.svg";